import React from 'react'
import { Navigate } from 'react-router-dom'
import { useCurrentPractice } from '../contexts/PracticeContext'
import LoadingSpinner from './LoadingSpinner'

type PaymentsGuardProps = {
	children: React.ReactNode
}

/**
 * Guard component to enable/disable all payment-related components.
 *
 * Usage:
 *   <PaymentsGuard>
 *     <PaymentPage />
 *   </PaymentsGuard>
 *
 * If payments are enabled, children are rendered; otherwise, they are hidden.
 */
const PaymentsGuard: React.FC<PaymentsGuardProps> = ({ children }) => {
	const { isPaymentEnabled, currentPracticeObject } = useCurrentPractice()

	if (!currentPracticeObject?.id) {
		return <LoadingSpinner />
	}

	if (!isPaymentEnabled) return <Navigate to="/dashboard" />

	return <>{children}</>
}

export default PaymentsGuard
